<template>
  <div>
    <vuestic-navbar>
      <header-selector slot="selector" :isOpen.sync="valueProxy"/>
      <span slot="logo">
        <img class="logo" src="../../../../public/logo2.png"/>
      </span>
      <span class="title--sucursal">{{sucursal}}</span>
      <sugerido-compra-carro v-if="$route.name === 'sugerido-compra'" />
      <label class="username"><p>Bienvenido!</p>{{nombre}}</label>
      <profile-dropdown class="user col nav-item">
        <img
          src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS0SeIKo0F_kGw7uKWOp-O7S-3bG19e0DOfLlY2cf9jDugJU2xu">
      </profile-dropdown>
    </vuestic-navbar>
  </div>
</template>

<script>
  import VuesticIconVuestic
    from '../../../vuestic-theme/vuestic-components/vuestic-icon/VuesticIconVuestic'
  import VuesticNavbar
    from '../../../vuestic-theme/vuestic-components/vuestic-navbar/VuesticNavbar'
  import HeaderSelector from './components/HeaderSelector'
  import LanguageDropdown from './components/dropdowns/LanguageDropdown'
  import ProfileDropdown from './components/dropdowns/ProfileDropdown'
  import NotificationDropdown from './components/dropdowns/NotificationDropdown'
  import MessageDropdown from './components/dropdowns/MessageDropdown'
  import Logout from '../../auth/logout/Logout'
  import VuesticModal from '../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal'
  import VuesticWidget from '../../../vuestic-theme/vuestic-components/vuestic-widget/VuesticWidget'
  import SugeridoCompraCarro from "../../compra/component/SugeridoCompraCarro";

  export default {
    name: 'app-navbar',

    components: {
      SugeridoCompraCarro,
      VuesticWidget,
      VuesticModal,
      Logout,
      VuesticIconVuestic,
      VuesticNavbar,
      HeaderSelector,
      MessageDropdown,
      NotificationDropdown,
      LanguageDropdown,
      ProfileDropdown,
    },
    props: {
      isOpen: {
        type: Boolean,
        required: true,
      },
    },
    data() {
      return {
        nombre: localStorage.getItem('nombre').toUpperCase(),
        sucursal: localStorage.getItem('sucursal').toUpperCase(),
        show: false
      }
    },
    computed: {
      valueProxy: {
        get() {
          return this.isOpen
        },
        set(opened) {
          localStorage.setItem('sidebar', opened)
          this.$emit('toggle-menu', opened)

        },
      },
    },
    methods: {
      verCarro() {
        this.$router.push('/ventas/carro-ventas')
      }
    }
  }
</script>
<style scoped lang="scss">
  p {
    margin: 0;
    position: relative;
  }

  label {
    font-weight: bold;
    color: white;
    font-size: 14px;
    margin-top: 17px;
    position: relative;
    bottom: 15px;
    left: 40px;
    text-align: center;
  }

  i {
    font-size: 28px;
    color: white;
    margin-top: 8px;
    cursor: pointer;
    margin-left: 2px;
  }

  img.logo {
    margin-left: 15px;
    margin-bottom: 5px;
    width: 260px;
    height: 100px;
  }

  .test-mode {
    position: absolute;
    right: 0;
    width: 100px;
    text-align: center;
    font-family: Open Sans, Source Sans Pro, Helvetica Neue, Microsoft Yahei, Arial, sans-serif;

    span {
      font-weight: bold;
      font-size: 12px;
      color: red;
    }
  }

  i.entypo {
    position: relative;
    right: 30px;
    cursor: pointer;
    height: 50%;
    width: 20px;

    &:hover {
      color: lightgreen;
    }
  }

  .title--sucursal {
    font-weight: bold;
    color: white;
    position: absolute;
    right: 0;
    width: 100%;
    left: 45%;
    align-items: center;
    font-size: 30px;
    font-family: 'Open Sans', 'Source Sans Pro', 'Helvetica Neue', 'Microsoft Yahei', Arial, sans-serif;

  }

  @media only screen and (max-width: 1290px) and (min-width: 200px) {
    .username {
      display: flex;
      align-items: center;
      flex-direction: column;
      left: 20px;
      margin-right: 20px;
      font-size: 15px;
    }
    .title--sucursal {

      position: absolute;
      right: 0;
      left: 80px;
      font-size: 18px;
    }
    .logo {
      display: none;
    }

    i.fa {
      font-size: 20px;
      top: 25px;
      left: -40px;
    }
  }
</style>
